
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"m4.305 8.707 3 3a1 1 0 0 0 1.414 0l3-3a1.00000525 1.00000525 0 1 0-1.389-1.439c-.009.008-.017.017-.025.025L9.012 8.586 9 3a1 1 0 0 0-2 0l.012 5.586-1.293-1.293A1.00000525 1.00000525 0 1 0 4.28 8.682l.025.025"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14 13H2a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  